<template>
  <div>
    <div class="alert alert-dismissible fade show" :class="alertType" v-if="displayAlert==true">
      <button
        type="button"
        aria-hidden="true"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <i class="nc-icon nc-simple-remove"></i>
      </button>
      <span>{{alertMsg}}</span>
    </div>

    <h4 class="subheading grey--text">Update Profile Details</h4>

    <div class="card">
      <div style="padding: 25px;">
        <form ref="newClientForm">
          <fg-input
            label="First Name"
            v-model="model.firstName"
            v-validate="modelValidations.firstName"
            name="firstName"
            type="text"
            :error="getError('firstName')"
            required
          ></fg-input>
          <fg-input
            label="Last Name"
            v-model="model.lastName"
            v-validate="modelValidations.lastName"
            name="lastName"
            type="text"
            :error="getError('lastName')"
            required
          ></fg-input>
          <fg-input
            label="City"
            v-model="model.city"
            v-validate="modelValidations.city"
            name="City"
            type="text"
            :error="getError('city')"
            required
          ></fg-input>
          <fg-input
            label="State"
            v-model="model.state"
            v-validate="modelValidations.state"
            name="state"
            type="text"
            :error="getError('state')"
            required
          ></fg-input>
          <fg-input
            label="Country"
            v-model="model.country"
            v-validate="modelValidations.country"
            name="country"
            type="text"
            :error="getError('country')"
            required
          ></fg-input>

          <p-button color="info" class="mr-4" type="submit" @click="onSubmit">SAVE PROFILE</p-button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import { mapActions, mapGetters } from "vuex";
// import IGProfileData from "../libs/ig/profileData";
import axios from "axios";
import VueCookies from "vue-cookies";
import store from "@/store/index.js";
import {
  userUpdateApi,
  actionCreateApi,
  userEmailUpdateApi,
  clientInviteReadApi,
  userRelatedProfilesApi,
  userLoadApi,
} from "@/config/appSettings";
export default {
  name: "Profile",
  data: () => ({
    profileResult: {},
    valid: true,
    saveOverlay: false,
    showForm: false,
    showIntro: true,
    firstname: null,
    lastname: null,
    fNameRules: [(v) => !!v || "First name is required"],
    lNameRules: [(v) => !!v || "Last name is required"],
    companyRules: [(v) => !!v || "Company name is required"],
    email: null,
    company: null,
    state: null,
    states: [],
    country: null,
    countries: [],
    city: null,
    cityRules: [(v) => !!v || "Enter a valid city"],
    username: "",
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    auth: null,
    isTeam: null,
    isInfluencer: null,
    isClient: null,
    model: {
      firstName: "",
      lastName: "",
      city: null,
      zip: null,
      country: null,
      state: null,
      region: "",
    },
    modelValidations: {
      firstName: {
        required: true,
      },
      lastName: {
        required: true,
      },
    },
  }),
  created() {
    this.email = firebase.auth().currentUser.email;
    this.auth = firebase.auth().currentUser.uid;
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
    ...mapActions(["createProfile", "emailContactUpdate", "actionCreateApi"]),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        console.log("CHECKING IS VALID:", isValid);
        console.log("CHECKING REGISTER FORM: ", this.registerForm);
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (
          this.relatedProfileStore == null ||
          typeof this.relatedProfileStore == "undefined"
        ) {
          let relatedProfileUrl = `${userRelatedProfilesApi}/?usertoken=${this.auth}`;
          //console.log("RELATED PROFILE URL:", relatedProfileUrl);
          let relatedProfileResponse = await axios.get(relatedProfileUrl);
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async setProfileType() {
      //console.log("PROFILE STORE:", this.profileStore);
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },
    async onSubmit(e) {
      e.preventDefault();
      const self = this;
      self.saveOverlay = true;

      let validateCheck = await this.$validator.validateAll();
      console.log("VALIDATING:", validateCheck);
      if (validateCheck == true) {
        let formInfo = {};
        formInfo.first_name = self.model.firstName;
        formInfo.last_name = self.model.lastName;
        formInfo.company_name = self.model.company;
        formInfo.city = self.model.city;
        formInfo.state = self.model.state;
        formInfo.country = self.model.country;
        formInfo.usertoken = firebase.auth().currentUser.uid;
        formInfo.email = firebase.auth().currentUser.email;
        if (this.isInfluencer == true) {
          formInfo.setFeatures = true;
        }

        // CHECK FOR CLIENT_REF COOKIE

        // ADD USER TO CLIENT CAMPAIGN
        //console.log("HERE IS THE RESULT: ", formInfo);
        //console.log(  "HERE IS THE INFO FROM FIREBASE: ",firebase.auth().currentUser.uid );

        try {
          console.log("SENDING FORM INFO:", formInfo)
          let createProfileResponse = await axios.post(userUpdateApi, formInfo);

          if (createProfileResponse.data.success === true) {
            // add create property to user object
            //console.log("HI :", createProfileResponse);

            firebase
              .auth()
              .currentUser.updateProfile({ displayName: "influencer" })
              .then(function () {
                self.savingOverlay = false;
                self.alertType = "alert-success";
                self.alertMsg = "Profile Updated Successfully.";
                self.displayAlert = true;
              });

            self.$router.push({
              path: "/dashboard",
              query: {
                msg_show: true,
                msg_type: "alert-success",
                msg: "Your profile is created! Let's get started!",
              },
            });
          } else {
            //console.log("THIS IS AN ERROR IN SUBMIT 2");
            self.saveOverlay = false;
            self.alertMsg = "There was an error. 2";
            self.alertType = "alert-danger";
            self.displayAlert = true;
          }
        } catch (err) {
          console.log(err);
          self.saveOverlay = false;
          self.alertMsg = "There was an error. 3";
          self.alertType = "alert-danger";
          self.displayAlert = true;
          return;
        }
      } else {
        self.saveOverlay = false;
        self.alertMsg = "There was an error. 4";
        self.alertType = "alert-danger";
        self.displayAlert = true;
      }
    },
    toggleForm() {
      this.showForm = true;
      this.showIntro = false;
    },
    async loadPageContent() {
      await this.setProfileType();
      await this.getRelatedProfiles();
      console.log("IS INFLUENCER:", this.isInfluencer)
    },
  },
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
</style>